<template>
  <div class="c-secondary-nav">
    <template v-for="(item, index) in navItems">
      <a
        v-if="item.externalLink"
        :key="'c-secondary-nav__'+index"
        :href="item.linkUrl"
        class="c-secondary-nav__item t-paragraph-large"
        :tabindex="tabindexStart+index"
        :class="{'l-grid__item--justify-start':index === 0,'l-grid__item--justify-center':index === 1,'l-grid__item--justify-end':index === 2}"
      >
        {{ item.linkText }}
      </a>
      <nuxt-link
        v-if="!item.externalLink"
        :key="'c-secondary-nav__'+index"
        :to="item.linkUrl"
        class="c-secondary-nav__item t-paragraph-large"
        :tabindex="tabindexStart+index"
        :class="{'l-grid__item--justify-start':index === 0,'l-grid__item--justify-center':index === 1,'l-grid__item--justify-end':index === 2}"
      >
        {{ item.linkText }}
      </nuxt-link>
    </template>
  </div>
</template>

<script>
export default {
  name: "SecondaryNav",
  props:{
    navItems: {
      type: Array,
      default: null
    },
    tabindexStart: {
      type: Number,
      default: 10
    }
  },
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .c-secondary-nav{
    padding: rem(20px) 0;
    margin-bottom: rem(20px);
    &__item{
      @include themify($themes){
        color: themed("foreground", "base");
      }
      text-decoration: none;
      display: block;
      margin-bottom: rem(17px);
      &:hover{
        @include themify($themes){
          color: themed("accent", "base");
        }
      }
    }
  }
</style>
